import { useEffect, useState } from "react";

function getMedia(width: number) {
    return width < 576
        ? "xs"
        : width < 768
        ? "sm"
        : width < 992
        ? "md"
        : width < 1200
        ? "lg"
        : "xl";
}

export default function useMedia() {
    const [media, setMedia] = useState<"xs" | "sm" | "md" | "lg" | "xl">(
        getMedia(window.innerWidth)
    );

    useEffect(() => {
        const handler = () => {
            setMedia(getMedia(window.innerWidth));
        };
        window.addEventListener("resize", handler);

        return () => window.removeEventListener("resize", handler);
    }, []);

    return media;
}
